import {alpha, Components} from '@mui/material';

import {Colors} from '@constants/colors.constants';

const menu: Components = {
  MuiPopper: {
    defaultProps: {
      sx: {
        zIndex: '2000 !important',
      },
    }
  },
  MuiMenu: {
    styleOverrides: {
      root: (props) => ({
        ...(props.ownerState?.['aria-label'] === 'small' ? {
          '& .MuiMenuItem-root': {
            fontSize: 14,
            height: 30,
          },
        } : {}),
        zIndex: 2000,
      }),
      paper: {
        backgroundColor: 'white',
        boxShadow: `0 8px 20px 0 ${alpha(Colors.black, 0.1)}`,
        padding: 0,
        margin: 0,
      },
      list: {
        maxHeight: '40vh',
        padding: 0,
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        flex: 1,
        height: 38,
        '&.Mui-selected': {
          fontWeight: 700,
        },
      },
    },
  },
};

export default menu;
